import * as React from 'react';
import styled from '../../styled';
import { Outline } from '../icons';
import { media } from '../../themes/breakpoint';
const OuterWrapper = styled.div `
  position: fixed;
  z-index: ${({ theme }) => theme.zIndex.POPUP};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 2rem;

  ${media.mobile `
    padding-left: 1rem;
    padding-right: 1rem;
	`};
`;
const Overlay = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.BLACK};
  opacity: 0.3;
`;
const InnerWrapper = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.POPUP + 1};
  max-width: ${({ width }) => width || '40rem'};
  ${({ height }) => height && `height: ${height};`}
  max-height: 100%;
  overflow: ${({ overflow }) => overflow || 'hidden'};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.SNOW_100};
  box-shadow: 0 2rem 3rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT},
    0 0.125rem 1rem 0 ${({ theme }) => theme.colors.SHADOW_DARK};
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  font-size: 1.125rem;
  padding: 1.5rem 2rem;
  background-color: ${({ theme }) => theme.colors.SNOW_200};
  border-radius: 8px 8px 0px 0px;

  ${media.mobile `
		padding: 1.5rem 1rem;
	`};
`;
const HeaderTitle = styled.p `
  display: inline-block;
  margin: 0;
  color: ${({ theme }) => theme.colors.INK_800};
  font-size: 1.125rem;
  font-weight: 600;
`;
const CloseIconWrapper = styled.div `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const Body = styled.div `
  flex: 1;
  ${({ hasBodyPadding }) => hasBodyPadding && 'padding: 2rem;'}
  overflow: ${({ overflow }) => overflow || 'auto'};
  font-size: 1rem;
  line-height: 1.5rem;

  ${({ hasBodyPadding }) => hasBodyPadding &&
    media.mobile `
    padding: 1rem;
  `}

  > * {
    margin: 0;
  }
`;
const Footer = styled.div `
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.colors.SNOW_200};
  text-align: right;
  border-radius: 0px 0px 8px 8px;

  > :not(:last-child) {
    margin-right: 1rem;
  }

  ${media.mobile `
		padding: 1rem;
	`};
`;
const Popup = ({ title, showCloseBtn = true, renderFooter, onClose, children, height, width, e2eId, hasBodyPadding = true, overflow, }) => (React.createElement(OuterWrapper, null,
    React.createElement(Overlay, { className: "Overlay", onClick: onClose }),
    React.createElement(InnerWrapper, { "data-e2e-id": e2eId, width: width, height: height, overflow: overflow },
        React.createElement(Header, null,
            React.createElement(HeaderTitle, null, title),
            showCloseBtn && (React.createElement(CloseIconWrapper, { className: "CloseIconWrapper", onClick: onClose },
                React.createElement(Outline.Cross, { size: "MEDIUM", color: "INK_500" })))),
        React.createElement(Body, { hasBodyPadding: hasBodyPadding, overflow: overflow }, children),
        renderFooter && React.createElement(Footer, null, renderFooter()))));
export default Popup;
//# sourceMappingURL=index.js.map